// @flow strict

import {
  type PropsWithChildren,
  TrackEvents,
  PaidButton,
} from '@mondough/public-web-components'
import React from 'react'
import PaidSectionWrapper from '../PaidSectionWrapper'
import styles from './CardRenderSection.module.scss'

type Props = {
  cta?: {
    href?: string,
    text?: string,
    gaAction?: string,
    gaCategory?: string,
    gaLabel?: string,
  },
  card?: string,
}

const CardRender = ({ cta, card, children }: PropsWithChildren<Props>) => {
  if (card == null) return null

  return (
    <PaidSectionWrapper contentClassName={styles.content}>
      {children}
      <div>
        <div className={styles.cardContainer}>
          <img src={card} alt="" className={styles.card} />
        </div>
        {cta && cta.text && (
          <div className={styles.buttonContainer}>
            <TrackEvents
              category={cta.gaCategory && 'deeplink'}
              action={cta.gaAction && ''}
              label={cta.gaLabel && ''}
            >
              <PaidButton href={cta.href}>{cta.text}</PaidButton>
            </TrackEvents>
          </div>
        )}
      </div>
    </PaidSectionWrapper>
  )
}

export default CardRender
